export default __webpack_public_path__ + "static/media/lock.6966327c.svg";